"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeSdkLoggers = void 0;
const logger_1 = require("@moojo/logger");
/**
 * Creates and returns a pair of loggers for SDK use.
 *
 * @returns {{ bootLogger: DefaultLogger, logger: DefaultLogger }} An object containing two loggers:
 *   - bootLogger: Uses the default log level (typically INFO or WARN). Intended for critical logs,
 *     especially during SDK initialization.
 *   - logger: Configurable verbosity based on the debug parameter. In non-debug mode (default),
 *     it only logs warnings and errors. In debug mode, it logs all levels including debug messages.
 */
const makeSdkLoggers = (prefix, debug = false) => {
    const bootLogger = new logger_1.DefaultLogger({
        usePrefix: prefix ? `[${prefix}]` : undefined,
    });
    const logger = new logger_1.DefaultLogger({
        level: debug ? logger_1.LogLevel.DEBUG : logger_1.LogLevel.WARN,
        usePrefix: prefix ? `[${prefix}]` : undefined,
    });
    return { bootLogger, logger };
};
exports.makeSdkLoggers = makeSdkLoggers;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFrZS1zZGstbG9nZ2Vycy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9tYWtlLXNkay1sb2dnZXJzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLDBDQUF1RDtBQUV2RDs7Ozs7Ozs7R0FRRztBQUNJLE1BQU0sY0FBYyxHQUFHLENBQUMsTUFBYyxFQUFFLFFBQWlCLEtBQUssRUFBRSxFQUFFO0lBQ3ZFLE1BQU0sVUFBVSxHQUFHLElBQUksc0JBQWEsQ0FBQztRQUNuQyxTQUFTLEVBQUUsTUFBTSxDQUFDLENBQUMsQ0FBQyxJQUFJLE1BQU0sR0FBRyxDQUFDLENBQUMsQ0FBQyxTQUFTO0tBQzlDLENBQUMsQ0FBQTtJQUVGLE1BQU0sTUFBTSxHQUFHLElBQUksc0JBQWEsQ0FBQztRQUMvQixLQUFLLEVBQUUsS0FBSyxDQUFDLENBQUMsQ0FBQyxpQkFBUSxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsaUJBQVEsQ0FBQyxJQUFJO1FBQzdDLFNBQVMsRUFBRSxNQUFNLENBQUMsQ0FBQyxDQUFDLElBQUksTUFBTSxHQUFHLENBQUMsQ0FBQyxDQUFDLFNBQVM7S0FDOUMsQ0FBQyxDQUFBO0lBRUYsT0FBTyxFQUFFLFVBQVUsRUFBRSxNQUFNLEVBQUUsQ0FBQTtBQUMvQixDQUFDLENBQUE7QUFYWSxRQUFBLGNBQWMsa0JBVzFCIn0=